/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandInfringementThreatTypeEnum } from './BrandInfringementThreatTypeEnum';
import {
    BrandInfringementThreatTypeEnumFromJSON,
    BrandInfringementThreatTypeEnumFromJSONTyped,
    BrandInfringementThreatTypeEnumToJSON,
    BrandInfringementThreatTypeEnumToJSONTyped,
} from './BrandInfringementThreatTypeEnum';
import type { InfringementEvent } from './InfringementEvent';
import {
    InfringementEventFromJSON,
    InfringementEventFromJSONTyped,
    InfringementEventToJSON,
    InfringementEventToJSONTyped,
} from './InfringementEvent';
import type { BrandInfringementSeverityEnum } from './BrandInfringementSeverityEnum';
import {
    BrandInfringementSeverityEnumFromJSON,
    BrandInfringementSeverityEnumFromJSONTyped,
    BrandInfringementSeverityEnumToJSON,
    BrandInfringementSeverityEnumToJSONTyped,
} from './BrandInfringementSeverityEnum';
import type { Status7f3Enum } from './Status7f3Enum';
import {
    Status7f3EnumFromJSON,
    Status7f3EnumFromJSONTyped,
    Status7f3EnumToJSON,
    Status7f3EnumToJSONTyped,
} from './Status7f3Enum';

/**
 * 
 * @export
 * @interface PatchedBrandInfringement
 */
export interface PatchedBrandInfringement {
    /**
     * 
     * @type {number}
     * @memberof PatchedBrandInfringement
     */
    readonly id?: number;
    /**
     * Title of the threat (e.g., news title, social media post, domain name)
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    threatTitle?: string;
    /**
     * Type of brand infringement threat
     * 
     * * `domain_threat` - Domain Threat
     * * `social_media` - Social Media
     * * `public_news` - Public News
     * @type {BrandInfringementThreatTypeEnum}
     * @memberof PatchedBrandInfringement
     */
    threatType?: BrandInfringementThreatTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    readonly threatTypeDisplay?: string;
    /**
     * Source where the threat was detected
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    source?: string;
    /**
     * Severity level of the threat
     * 
     * * `critical` - Critical
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     * * `info` - Informational
     * @type {BrandInfringementSeverityEnum}
     * @memberof PatchedBrandInfringement
     */
    severity?: BrandInfringementSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    readonly severityDisplay?: string;
    /**
     * Confidence level from 0-100%, null indicates Unknown
     * @type {number}
     * @memberof PatchedBrandInfringement
     */
    confidenceLevel?: number | null;
    /**
     * Current status of the infringement investigation
     * 
     * * `new` - New
     * * `detected` - Detected
     * * `investigating` - Investigating
     * * `reported` - Reported
     * * `takendown` - Taken Down
     * @type {Status7f3Enum}
     * @memberof PatchedBrandInfringement
     */
    status?: Status7f3Enum;
    /**
     * 
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    readonly statusDisplay?: string;
    /**
     * Screenshot of the infringing content
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    screenshot?: string | null;
    /**
     * Detailed description of the infringement
     * @type {string}
     * @memberof PatchedBrandInfringement
     */
    description?: string;
    /**
     * Date when the infringement was detected
     * @type {Date}
     * @memberof PatchedBrandInfringement
     */
    readonly dateDetected?: Date;
    /**
     * 
     * @type {Array<InfringementEvent>}
     * @memberof PatchedBrandInfringement
     */
    readonly timelineEvents?: Array<InfringementEvent>;
    /**
     * 
     * @type {Date}
     * @memberof PatchedBrandInfringement
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedBrandInfringement
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedBrandInfringement interface.
 */
export function instanceOfPatchedBrandInfringement(value: object): value is PatchedBrandInfringement {
    return true;
}

export function PatchedBrandInfringementFromJSON(json: any): PatchedBrandInfringement {
    return PatchedBrandInfringementFromJSONTyped(json, false);
}

export function PatchedBrandInfringementFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedBrandInfringement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'threatTitle': json['threat_title'] == null ? undefined : json['threat_title'],
        'threatType': json['threat_type'] == null ? undefined : BrandInfringementThreatTypeEnumFromJSON(json['threat_type']),
        'threatTypeDisplay': json['threat_type_display'] == null ? undefined : json['threat_type_display'],
        'source': json['source'] == null ? undefined : json['source'],
        'severity': json['severity'] == null ? undefined : BrandInfringementSeverityEnumFromJSON(json['severity']),
        'severityDisplay': json['severity_display'] == null ? undefined : json['severity_display'],
        'confidenceLevel': json['confidence_level'] == null ? undefined : json['confidence_level'],
        'status': json['status'] == null ? undefined : Status7f3EnumFromJSON(json['status']),
        'statusDisplay': json['status_display'] == null ? undefined : json['status_display'],
        'screenshot': json['screenshot'] == null ? undefined : json['screenshot'],
        'description': json['description'] == null ? undefined : json['description'],
        'dateDetected': json['date_detected'] == null ? undefined : (new Date(json['date_detected'])),
        'timelineEvents': json['timeline_events'] == null ? undefined : ((json['timeline_events'] as Array<any>).map(InfringementEventFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedBrandInfringementToJSON(json: any): PatchedBrandInfringement {
      return PatchedBrandInfringementToJSONTyped(json, false);
  }

  export function PatchedBrandInfringementToJSONTyped(value?: Omit<PatchedBrandInfringement, 'id'|'threat_type_display'|'severity_display'|'status_display'|'date_detected'|'timeline_events'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'threat_title': value['threatTitle'],
        'threat_type': BrandInfringementThreatTypeEnumToJSON(value['threatType']),
        'source': value['source'],
        'severity': BrandInfringementSeverityEnumToJSON(value['severity']),
        'confidence_level': value['confidenceLevel'],
        'status': Status7f3EnumToJSON(value['status']),
        'screenshot': value['screenshot'],
        'description': value['description'],
    };
}

